import makeTable from "./makeTable";

const carSelectTab = makeTable({
	allIds: [
		"parkNumber",
		"aliases",
		"mark",
		"model",
		"registrationNumber",
		"color",
		"class",
		"bodyType",
		"registeredAt",
		"carParkId",
		"responsibleDispatcher",
		"company",
		"taxiService",
		"note",
	],
	i18tPath: (id) => `carSelectTab.${id}`,
	initialSortMethod: {
		column: "parkNumber",
		type: "asc",
	},
	defaultIds: [
		"parkNumber",
		"aliases",
		"mark",
		"model",
		"registrationNumber",
		"color",
		"class",
		"bodyType",
		"registeredAt",
		"carParkId",
		"responsibleDispatcher",
		"company",
		"taxiService",
		"note",
	],
	initialWidths: {
		parkNumber: 100,
		aliases: 120,
		mark: 120,
		model: 120,
		registrationNumber: 120,
		color: 100,
		class: 100,
		bodyType: 120,
		registeredAt: 90,
		carParkId: 150,
		responsibleDispatcher: 150,
		company: 130,
		taxiService: 100,
		note: 200,
	},
	initialResizable: {
		parkNumber: true,
		aliases: true,
		mark: true,
		registrationNumber: true,
		color: true,
		model: true,
		class: true,
		bodyType: true,
		registeredAt: true,
		carParkId: true,
		responsibleDispatcher: true,
		company: true,
		taxiService: true,
		note: true,
	},
	initialSortable: {
		parkNumber: true,
		aliases: true,
		mark: true,
		registrationNumber: true,
		color: true,
		model: true,
		class: true,
		bodyType: true,
		registeredAt: true,
		carParkId: true,
		responsibleDispatcher: true,
		company: true,
		taxiService: true,
		note: true,
	},
});

export default carSelectTab;
